// @TODO: Update during ticket BDBB-813
import { mapStore } from '../../state/mapStore'
export const calculateMobileMapHeight = () => {
    const { activeTab, directionCoordinates, showStopAdd } = mapStore.getState()
    if (activeTab === 'breweries') return 'calc(100vh - 19rem)'
    switch (directionCoordinates.length) {
        case 1: {
            return `calc(100vh - 24rem)`
        }
        case 2: {
            return `calc(100vh - ${showStopAdd ? '31rem' : '28rem'})`
        }
        default: {
            return `calc(100vh - ${showStopAdd ? '33rem' : '30rem'})`
        }
    }
}
